import React, { Component, PureComponent, Fragment } from 'react'

export default class FileInput extends Component {
  render() {
    return <div>Show file input</div>
  }
}
